export default __webpack_public_path__ + "navigation-examples-custom-navigation-camera-thumbnail-480-afa5cd867f03c0e771f55f59b8939c14.png";